import { Component } from '@angular/core';
import { BasicDialogComponent } from '@shared/components/dialogs/basic-dialog.component';
import { MemberStatesEnums } from '@shared/enums/memberState.enum';

@Component({
    standalone: false,
    selector: 'app-member-state-option-choice-dialog',
    templateUrl: './member-state-option-choice-dialog.component.html'
})
export class MemberStateOptionChoiceDialogComponent extends BasicDialogComponent {

    readonly memberStatesEnums = MemberStatesEnums;

    constructor() {
        super();
    }
}
